import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user.png'


const _withScopeId = n => (_pushScopeId("data-v-2e772fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }),
    /*#__PURE__*/_createTextVNode("ข้อมูลการสั่งการหรือเร่งรัดโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลการสั่งการหรือเร่งรัดโครงการจาก ร.นรม./รมต.นร. ที่รับผิดชอบ")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-reply me-2" }, null, -1))
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }),
    /*#__PURE__*/_createTextVNode("การสั่งการหรือเร่งรัดโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "ข้อมูลการสั่งการหรือเร่งรัดโครงการจาก ร.นรม./รมต.นร. ที่รับผิดชอบ")
], -1))
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = { class: "card card-sub" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-auto d-flex justify-content-center align-items-center" }
const _hoisted_14 = { class: "photo text-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }),
  /*#__PURE__*/_createTextVNode("ผู้สั่งการหรือเร่งรัดโครงการ:")
], -1))
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-certificate me-2" }),
  /*#__PURE__*/_createTextVNode("ตำแแหน่ง:")
], -1))
const _hoisted_21 = { class: "text-muted mb-0" }
const _hoisted_22 = { class: "col-sm-8" }
const _hoisted_23 = { class: "card card-sub mb-3" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-circle me-2" }),
  /*#__PURE__*/_createTextVNode("เรื่อง:")
], -1))
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-clock me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่สั่งการหรือเร่งรัดโครงการ:")
], -1))
const _hoisted_32 = { class: "text-muted mb-0" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-comment-alt me-2" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "card card-sub"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center text-danger p-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ยังไม่ได้รายงานผล ")
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "card card-sub" }
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "profile text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-fluid rounded-circle profile-image mb-2",
      src: _imports_0,
      alt: "avatar"
    })
  ])
], -1))
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user me-2" }),
  /*#__PURE__*/_createTextVNode("ผู้รายงานผล:")
], -1))
const _hoisted_45 = { class: "text-muted" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-certificate me-2" }),
  /*#__PURE__*/_createTextVNode("สิทธิ์การใช้งาน:")
], -1))
const _hoisted_47 = { class: "text-muted mb-0" }
const _hoisted_48 = { class: "col-sm-8" }
const _hoisted_49 = { class: "card card-sub mb-3" }
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_53 = { class: "text-muted" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-clock me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่รายงานผล:")
], -1))
const _hoisted_55 = { class: "text-muted mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_ProjectResultComponent = _resolveComponent("ProjectResultComponent")!
  const _component_EnjoinAnswerFormComponent = _resolveComponent("EnjoinAnswerFormComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToProject && _ctx.backToProject(...args)))
              }, [
                _hoisted_4,
                _createTextVNode("ข้อมูลโครงการ ")
              ]),
              _createVNode(_component_ProjectResultComponent, {
                "project-id": _ctx.project?.id,
                showEnjoins: false
              }, null, 8, ["project-id"])
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              class: "photo-image",
                              src: _ctx.enjoin?.ministerEnjoin.ministerPhoto,
                              width: "60",
                              height: "70",
                              alt: "preview"
                            }, null, 8, _hoisted_15)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.enjoin?.ministerEnjoin.ministerName), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_20,
                            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.enjoin?.ministerEnjoin.ministerPosition), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.enjoin?.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("p", _hoisted_30, null, 512), [
                          [_directive_dompurify_html, _ctx.enjoin?.description.replace(/(?:\r\n|\r|\n)/g, '<br />')]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_31,
                        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.thaiDate(_ctx.enjoin?.createdAt)), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary mb-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.replyClick && _ctx.replyClick(...args)))
              }, [
                _hoisted_33,
                _createTextVNode("รายงานผลการสั่งการหรือเร่งรัดโครงการ ")
              ]),
              (_ctx.enjoin?.answers.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.enjoin?.answers, (answer, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "row"
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _hoisted_44,
                                  _createElementVNode("p", _hoisted_45, _toDisplayString(answer.userName), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_46,
                                  _createElementVNode("p", _hoisted_47, _toDisplayString(answer.userRole), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _withDirectives(_createElementVNode("p", _hoisted_53, null, 512), [
                                [_directive_dompurify_html, answer?.description.replace(/(?:\r\n|\r|\n)/g, '<br />')]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_54,
                              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.thaiDate(answer?.createdAt)), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
            ], 64))
      ])
    ]),
    _createVNode(_component_EnjoinAnswerFormComponent, {
      ref: "enjoinAnswerForm",
      "enjoin-id": _ctx.enjoin?.id
    }, null, 8, ["enjoin-id"])
  ], 64))
}